import { render, staticRenderFns } from "./UserRights.vue?vue&type=template&id=1534dc56&scoped=true"
import script from "./UserRights.vue?vue&type=script&lang=js"
export * from "./UserRights.vue?vue&type=script&lang=js"
import style0 from "./UserRights.vue?vue&type=style&index=0&id=1534dc56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1534dc56",
  null
  
)

export default component.exports